import { t } from "i18next";
import { Duration } from "luxon";

export const getParkingTimeText = (remaining: number): string => {
  const duration = Duration.fromMillis(remaining).shiftTo("hours", "minutes", "seconds");
  const hours = duration.hours;
  const minutes = duration.minutes;
  const seconds = Math.floor(duration.seconds);
  let txt = "";

  if (hours > 0) txt += `${hours} `;
  if (hours === 1) txt += t("global.timeFull.hour1") + " ";
  if (hours >= 2 && hours <= 4) txt += t("global.timeFull.hour2_4") + " ";
  if (hours > 4) txt += t("global.timeFull.hour5+") + " ";

  if (minutes > 0) txt += `${minutes} `;
  if (minutes === 1) txt += t("global.timeFull.minute1");
  if (minutes >= 2 && minutes <= 4) txt += t("global.timeFull.minute2_4");
  if (minutes > 4) txt += t("global.timeFull.minute5+");

  if (minutes === 0) {
    txt += `${seconds} `;
    if (seconds === 1) txt += t("global.timeFull.second1");
    if (seconds >= 2 && seconds <= 4) txt += t("global.timeFull.second2_4");
    if (seconds > 4 || seconds === 0) txt += t("global.timeFull.second5+");
  }

  return txt;
};
